import "./base/";
import "./utilities/is-touch";
import "./utilities/responsive-images";
import "./cart/cart";
import "./cart/cart-utils";
import "./sliders/product-slider";
import "./sliders/hero-slider";
import "./sliders/review-slider";
import "./sliders/feature-slider";
import "./sliders/tier-slider";
import "./sliders/card-slider";
import "./sliders/addon-slider";
import "./sliders/articles-slider";
import "./product/ajax-actions";
import "./product/quantity";
import "./product/variants";
import "./polyfills/object-fit";
import "./modules/burger";
import "./modules/dropdown";
import "./modules/footer-accordion";
import "./modules/footer";
import "./modules/scroll";
import "./modules/accordion";
import "./modules/header";
import "./modules/product-popup";

const $win = $(window);
const $doc = $(document);

// Your code goes here...
// jQuery.ready is no longer needed
